var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 11.9072L10.0023 8.57606L6.67117 11.9072",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0022 16.0713L10.0022 8.57617",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3973 13.6478C18.1214 13.1387 18.6643 12.4121 18.9474 11.5735C19.2305 10.7348 19.239 9.82781 18.9716 8.98404C18.7043 8.14026 18.1751 7.40362 17.4607 6.88102C16.7463 6.35842 15.884 6.07705 14.9989 6.07774H13.9496C13.6991 5.1016 13.2305 4.195 12.5789 3.4262C11.9274 2.65739 11.1099 2.04641 10.188 1.63926C9.26619 1.2321 8.26399 1.03938 7.25688 1.07559C6.24977 1.11181 5.264 1.37603 4.37378 1.84835C3.48356 2.32067 2.71209 2.98879 2.11744 3.80241C1.5228 4.61603 1.12048 5.55395 0.940771 6.54556C0.761062 7.53717 0.808648 8.55662 1.07995 9.52718C1.35124 10.4977 1.83918 11.3941 2.50703 12.1488",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadZip);
export default __webpack_public_path__ + "static/media/upload_zip.b5492d73e5257f4cc739d00a3fe90b10.svg";
export { ForwardRef as ReactComponent };